/**
 * Returns an object with `availableForTesting` param whether `trainingId` is
 * defined and `option` is "available".
 */
export const getAvailableForTestingParam = (
  trainingId?: number,
  option?: string
) => ({
  availableForTesting:
    trainingId && option && option === 'available' ? trainingId : undefined,
})
